// extracted by mini-css-extract-plugin
module.exports = {"initialsAvatar":"styles_initialsAvatar__mIM7s"};